import React, { useState } from "react";
import { ExportButton, ExportButtonsContainer, ExportLabel } from "./export-buttons.styles";

const FORMATS = [
  { format: "xlsx", label: "XLSX" },
  { format: "csv", label: "CSV" },
  { format: "json", label: "JSON" },
  { format: "pdf", label: "PDF" },
];

const DownloadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 19h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface ExportButtonsProps {
  onExport: (format: string) => Promise<void>;
}

export function ExportButtons({ onExport }: ExportButtonsProps) {
  const [loadingFormat, setLoadingFormat] = useState<string | null>(null);

  const handleClick = async (format: string) => {
    setLoadingFormat(format);
    try {
      await onExport(format);
    } finally {
      setLoadingFormat(null);
    }
  };

  return (
    <ExportButtonsContainer>
      <ExportLabel>Exportar:</ExportLabel>
      {FORMATS.map(({ format, label }) => (
        <ExportButton
          key={format}
          disabled={loadingFormat !== null}
          onClick={() => handleClick(format)}
        >
          <DownloadIcon /> {loadingFormat === format ? "Gerando..." : label}
        </ExportButton>
      ))}
    </ExportButtonsContainer>
  );
}
